import React from "react";
import {Div, H1, Button} from "glamorous";
import styles from "../../styles";
import data from "../../data";
import ScrollFixedContainer from "../common/ScrollFixedContainer";
import PreviewRead from "./Preview/Read";
import InputField from "./EditorTemplate/InputField";
import {track} from "../../misc/utils";


class EditorTemplate extends React.Component {

  updateText(text, index) {
    if (index === 1) {
      text = text.toUpperCase();
    }
    this.props.updateText(text, index);
  }

  render() {
    const {
      handlePreviewMyBottle,
      label
    } = this.props;

    let previewWrapperRef = null;

    return (
      <Div className="container">
      <H1 css={styles.editor.title}>{data.copy("templateEditorHeading")}</H1>
      <Div css={styles.editor.columnWrapper}>
        <ScrollFixedContainer>
          <Div
            innerRef={el => (previewWrapperRef = el)}
            css={styles.editMain.previewWrapper}
          >
            <PreviewRead
              label={label}
              handleTextClick={() => {}}
            />
          </Div>
        </ScrollFixedContainer>
        <Div css={styles.editor.rightCol}>
          <Div css={styles.editor.boxShadow}>
            {label.text.map((text, index) => (
              <InputField
                text={text}
                key={index}
                label={data.copy('line' + (index+1))}
                onChange={evt => this.updateText(evt.target.value, index)}
              />
            ))}

            <Button
              onClick={() => {
                const {width, height} = previewWrapperRef.getBoundingClientRect();
                handlePreviewMyBottle(width, height);
              }}
              marginTop="15px"
              css={styles.ctas.initial}
            >
              {data.copy("editorPreviewBtn")}
            </Button>

            <Button
              onClick={() => {
                track.event('button', 'click', 'editor_simple_start_again');
                this.props.resetLabel();
              }}
              marginTop="10px"
              css={styles.ctas.outline}
            >
              {data.copy("textResetBtn")}
            </Button>
          </Div>
        </Div>
      </Div>
      </Div>
    );
  }
}

export default EditorTemplate;



// WEBPACK FOOTER //
// ./src/components/areas/EditorTemplate.js